import { object } from 'prop-types';

export const UnsupportedQuestionType = ({ question, exam }) => {
  // eslint-disable-next-line no-console
  console.error(
    `Invalid Question Set State: QuestionId: ${question?.get(
      'id'
    )}, Type: ${question?.get('question_type')}, ExamId: ${exam?.get('id')}`
  );
  return <div>This question is not yet supported within a Question Set.</div>;
};

UnsupportedQuestionType.propTypes = {
  question: object.isRequired,
  exam: object.isRequired,
};
